import { FunctionComponent } from 'react';
import Stack from '@mui/material/Stack';
import { ISidebarFiltersProps } from './SidebarFilters.interface';

export const SidebarFilters: FunctionComponent<ISidebarFiltersProps> = ({ filters, mini, isFullyExpanded }) => {
  if (!filters) {
    return null;
  }

  if (Array.isArray(filters)) {
    return (
      <Stack sx={{
        overflow: 'auto',
      }}>
        {filters.map((FilterElement, index) => {
          return <FilterElement key={index} mini={mini} isFullyExpanded={isFullyExpanded} />;//NOSONAR
        })}
      </Stack>
    );
  }

  const SidebarFiltersComponent = filters;

  return <SidebarFiltersComponent mini={mini} isFullyExpanded={isFullyExpanded} />;
};
